<template>
  <div class="m-1 bg-white border rounded-md p-4">
    <div class="w-full flex justify-between items-center mt-8 pb-2">
      <h1 class="font-bold text-4xl">Start the claims process with Addify</h1>
    </div>
    <div class="pb-4">
      <p class="pb-2">
        In order to serve you better and make sure claims are processed sooner, we are asking our customers to start the claims process by submitting an intake form. Addify will contact you within 2 business days to verify and collect any additional information.
      </p>
      <p class="pb-2 font-semibold">Start the process by:</p>
      <ul class="list-disc list-inside space-y-2 ml-4">
        <li>
          emailing <a href="mailto:claims-intake@getaddify.com" class="text-blue-600 hover:underline">claims-intake@getaddify.com</a>
        </li>
        <li>
          calling 
          <a href="tel:+17272660465" class="text-blue-600 hover:underline mx-1">1-727-266-0465</a>
          <a href="tel:+17272660465" class="ml-2 inline-flex items-center text-blue-600 hover:underline text-sm">
            <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
            </svg>
            call now
          </a>
        </li>
        <li>
          submitting a claims-intake form at <a href="https://getaddify.com/claims-intake" target="_blank" class="text-blue-600 hover:underline">getaddify.com/claims-intake</a>
        </li>
      </ul>
    </div>
  </div>
</template>
